export const badgeStyle = {
  fontSize: '13px',
  '.MuiBadge-badge': {
    top: '-2px',
    right: '-5px',
    fontSize: '10px',
    fontWeight: '700',
    padding: '1px 3px',
    height: '12px',
    borderRadius: '6px',
    color: '#005AA9',
    background: '#DAEDFF',
  },
};

export const badgeStyle2 = {
  fontSize: '13px',
  '.MuiBadge-badge': {
    top: '-2px',
    right: '-5px',
    fontSize: '10px',
    fontWeight: '700',
    padding: '1px 3px',
    height: '12px',
    borderRadius: '6px',
    color: 'red',
    background: 'red',
  },
};

export const customInputStyle = {
  '.MuiInputBase-root': {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
};

export const InputStyle = {
  marginTop: '5px',
  width: '100%',
  height: '40px',
  '.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '10px',
  },
  '.MuiInputBase-input': {
    padding: '10px 12px',
    fontFamily: 'Lato',
    fontSize: '14px',
    lineHeight: '20px',
  },
  '.MuiFormHelperText-root': {
    padding: '0',
    margin: '0',
  },
  '.Mui-disabled': {
    background: '#f0f0f0',
  },
};

export const SelectSumStyle = {
  marginTop: '5px',
  width: '100%',
  height: '40px',
  '.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
    padding: '10px',
  },
  '.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '.MuiInputBase-input': {
    padding: '10px 12px',
    fontFamily: 'Lato',
    fontSize: '14px',
    lineHeight: '20px',
  },
};

export const SelectSumStyle2 = {
  width: '150px',
  marginTop: '5px',

  '.MuiInputBase-root ': {
    padding: '0 0 0 4px',
    height: '40px',
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  '.MuiFormHelperText-root': {
    margin: '0',
  },
};

export const SelectStyle = {
  width: '100%',
  mt: '5px',
  '.MuiInputBase-root ': {
    padding: '0 0 0 4px',
    height: '40px',
    width: '100%',
  },
  '.MuiFormHelperText-root': {
    margin: '0',
  },
  '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
    fontSize: '14px',
  },
  '.Mui-disabled': {
    background: '#f0f0f0',
  },
};

export const SelectInputStyle = {
  '.MuiInputBase-root .MuiInputBase-input': {
    padding: '10px 10px',
    fontSize: '14px',
    color: '#4D4D4D',
    lineHeight: '20px',
    mt: 0,
  },
};

export const SelectSumStyle3 = {
  '.MuiInputBase-root .MuiInputBase-input': {
    padding: '10px',
    fontSize: '14px',
  },
};

export const inputDataPicker = (error: any) => {
  return {
    width: '100%',

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: error ? '1px solid red' : '1px solid #C0C0C0',
      },
    },
    '.MuiInputBase-input': {
      padding: '0 0 0 12px',
      height: '40px',
    },
    '.Mui-disabled': {
      background: '#f0f0f0',
    },
    '.MuiButtonBase-root': {
      color: '#C0C0C0',
      '& svg': {
        width: '20px',
        header: '20px',
      },
    },
  };
};

export const inputDataPicker2 = () => {
  return {
    width: '100%',

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '1px solid #C0C0C0',
      },
    },
    '.MuiInputBase-input': {
      padding: '0 0 0 12px',
      height: '40px',
    },
    '.Mui-disabled': {
      background: '#f0f0f0',
    },
    '.MuiButtonBase-root': {
      color: '#C0C0C0',
      '& svg': {
        width: '20px',
        header: '20px',
      },
    },
  };
};

export const dataGridModalStyle = {
  '.MuiDataGrid-main': {
    height: '100%',
  },
  '.MuiDataGrid-columnHeadersInner': {
    backgroundColor: '#F3F8FC',
    borderRadius: '5px',
  },
  '.MuiDataGrid-cell': {
    minHeight: '38px !important',
    maxHeight: '38px !important',
  },
  '.MuiDataGrid-row': {
    minHeight: '38px !important',
    maxHeight: '38px !important',
    border: '1px solid #005AA9',
    borderRadius: '5px',
    marginTop: '10px',
  },
};

export const dataGridStyle = (loading: boolean, length: number) => {
  return {
    '&.MuiDataGrid-root .MuiDataGrid-main': {
      height: loading ? '300px' : length === 0 ? '300px' : length < 20 ? '100%' : '76vh',

      '@media only screen and (max-width: 1580px)': {
        height: loading ? '300px' : length === 0 ? '300px' : length < 20 ? '100%' : '72vh',
      },
      '@media only screen and (max-width: 1380px)': {
        height: loading ? '300px' : length === 0 ? '300px' : length < 20 ? '100%' : '70vh',
      },
      '@media screen and (max-width: 1480px) and (max-height: 920px)': {
        height: loading ? '300px' : length === 0 ? '300px' : length < 20 ? '100%' : '62vh',
      },
    },

    '&.MuiDataGrid-root': {
      padding: '0 !important',
      border: 'none !important',
      background: '#F7F8FB !important',
      borderRadius: '5px',
      margin: 0,
    },

    '&.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
      border: 'none !important',
    },

    '.MuiDataGrid-row': {
      background: '#fff !important',
      borderTop: '10px solid #F7F8FB',
      maxHeight: '40px !important',
      minHeight: '40px !important',
      display: 'flex',
      alignItems: 'center',
      overflowY: 'hidden !important',
      cursor: 'pointer',
      '&:last-child': {
        borderBottom: '0px solid #F7F8FB',
      },
    },

    '&.MuiDataGrid-root .MuiDataGrid-columnHeaders': {
      background: '#fff !important',
      border: 'none !important',
      minHeight: '56px !important',
      maxHeight: '56px !important',
    },

    '.MuiDataGrid-columnHeaderTitle': {
      fontSize: '14px !important',
      fontFamily: 'Lato',
      fontWeight: '700 !important',
      color: '#000',
    },

    '&.MuiDataGrid-root .MuiDataGrid-iconSeparator': {
      display: 'none !important',
    },

    ' &.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
      fontSize: '14px !important',
      fontFamily: 'Lato',
      fontWeight: '500 !important',
      color: '#4D4D4D !important',
    },

    '.MuiDataGrid-row:hover': {
      background: '#F3F8FC !important',
    },

    '.MuiDataGrid-footerContainer': {
      display: 'none',
    },
  };
};

export const dataGridStyle2 = {
  '&.MuiDataGrid-root': {
    padding: '0 !important',
    border: 'none !important',
    background: '#F7F8FB !important',
    borderRadius: '5px',
    margin: 0,
  },

  '&.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
    border: 'none !important',
  },

  '.MuiDataGrid-row': {
    background: '#fff !important',
    borderTop: '10px solid #F7F8FB',
    maxHeight: '40px !important',
    minHeight: '40px !important',
    display: 'flex',
    alignItems: 'center',
    overflowY: 'hidden',
    cursor: 'pointer',
    '&:last-child': {
      borderBottom: '0px solid #F7F8FB',
    },
  },

  '&.MuiDataGrid-root .MuiDataGrid-columnHeaders': {
    background: '#fff !important',
    border: 'none !important',
    minHeight: '56px !important',
    maxHeight: '56px !important',
  },

  '.MuiDataGrid-columnHeaderTitle': {
    fontSize: '14px !important',
    fontFamily: 'Lato',
    fontWeight: '700 !important',
    color: '#000',
  },

  '&.MuiDataGrid-root .MuiDataGrid-iconSeparator': {
    display: 'none !important',
  },

  ' &.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
    fontSize: '14px !important',
    fontFamily: 'Lato',
    fontWeight: '500 !important',
    color: '#4D4D4D !important',
  },

  '.MuiDataGrid-row:hover': {
    background: '#F3F8FC !important',
  },

  '.MuiDataGrid-footerContainer': {
    display: 'none',
  },
};

export const accountDropDownStyle = {
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
  mt: 1.5,
  '& .MuiAvatar-root': {
    width: 32,
    height: 32,
    ml: -0.5,
    mr: 1,
  },
  '&:before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 14,
    width: 10,
    height: 10,
    bgcolor: 'background.paper',
    transform: 'translateY(-50%) rotate(45deg)',
    zIndex: 0,
  },
};

export const dropDownStyle = {
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
  mt: 1.5,
  '& .MuiAvatar-root': {
    width: 35,
    height: 32,
    ml: -0.5,
    mr: 1,
  },
};
